<div class="create-exam-container">
  <app-learnset-selection-list [learnsets]="course?.learnsets" (examLearnsetsChange)="handleExamLearnsetsChange($event)" (totalCountChange)="totalCount = $event"></app-learnset-selection-list>
  <p class="error-message" [class.hidden]="!errorVisible">{{errorText}}</p>
  <app-button [text]="'Probeklausur erstellen'" [loading]="isLoading" (clickEvent)="createExam()"></app-button>
</div>